// 计费单

import { HttpGetInventoryBatchSnapshot, HttpGetInventoryBatchSnapshotExport,HttpGetProduct } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList, mixin],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            products:[],
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
            this.updateList();
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryBatchSnapshot,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    });
            }
            
        },
        interceptRequest(params) {
            
            params.state = this.isAdmin() ? '1' : '0';
            this.formData.state = params.state;
            return params
            
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryBatchSnapshotExport, this.formData, 'download').then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerBatchSnapshot';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSelfmanageorgList','getBillcusorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse']),
        // ...mapGetters('common', ['getInventoryType', 'getInventorySnapshotType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).map(function (item = "") {
                        return { value: item.attach.code, label: item.label };
                    }),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventorySnapshotType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inbound.batch_no', { defaultValue: "批次号" }),
                    key: 'EQ_batchNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.plan_order', { defaultValue: "计划单号" }),
                    key: 'CN_planNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.stock_update_date', { defaultValue: "库存更新日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('fbb.inventory.snap_shot_date', { defaultValue: "库存快照日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_fetchDate',
                    show: true,
                    default: this.handleDateRange().join(' ~ '),
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdmin() ? this.getCusproductList : this.getProductList,
                            row.lineId
                        )
                },
                {
                    title: this.$t('fbb.inbound.batch_no', { defaultValue: '批次号' }),
                    key: 'batchNo',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventorySnapshotType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.now_number', { defaultValue: '当前数量' }),
                    key: 'qtyCurrent',
                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('fbb.inventory.plan_order', { defaultValue: '计划单号' }),
                    key: 'planNo',
                },
                {
                    title: this.$t('fbb.inventory.stock_update_date', { defaultValue: '库存更新日期' }),
                    key: 'operateAt',
                },
                {
                    title: this.$t('fbb.inventory.system_catch_date', { defaultValue: '系统抓取时间' }),
                    key: 'fetchAt',
                },
                {
                    title: this.$t('fbb.inventory.snap_shot_date', { defaultValue: '库存快照日期' }),
                    key: 'fetchDate',
                },
            ];
        },
    },
};




